




























import { Component, Vue } from "vue-property-decorator";
import { Font } from "@/services/fonts/types";

    @Component
export default class FontDeleteModal extends Vue {
    // local
    localFont = {} as Font;
    isSaved: boolean = false;

    // methods
    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") this.confirm();
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
        this.isSaved = false;
    }

    open(item: Font) {
        this.localFont = item;
        this.$bvModal.show("modal-deleteFont");
        window.addEventListener("keydown", this.handleEnter);
    }

    decline() {
        this.$bvModal.hide("modal-deleteFont");
    }

    confirm() {
        if (this.isSaved) return;
        this.isSaved = true;
        this.$emit("deleteFont", this.localFont);
        this.$bvModal.hide("modal-deleteFont");
    }
}
